import {Component, Inject, OnInit} from '@angular/core';
import {Country} from '../../registration-dialog/types/country.types';
import {LoggedUser} from '../../../../types/loggedUser';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {LocalStorageService} from '../../../../../api/services/localStorage';
import {Competitor} from '../../../../types/competitor';
import {LoggedCompetitor} from '../../../../types/loggedCompetitor';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CountryService} from '../../../../../api/services/country.service';
import {HttpHandlingService} from '../../../../../api/services/http-handling.service';
import {UntypedFormControl, Validators} from '@angular/forms';
import {SERVER_API_URL} from '../../../../types/app.constants';

@Component({
  selector: 'app-edit-competitor-card',
  templateUrl: './edit-competitor-card.component.html',
  styleUrls: ['./edit-competitor-card.component.css']
})
export class EditCompetitorCardComponent implements OnInit {

  competitor: Competitor;

  firstName: string;
  lastName: string;
  selectedCountry: string;
  idNumber: string;
  dateOfBirth: Date;
  address: string;
  phone: string;

  country = Country;
  countries: string[];

  firstNameFieldControl = new UntypedFormControl('', Validators.required);
  lastNameFieldControl = new UntypedFormControl('', Validators.required);
  idNumberFieldControl = new UntypedFormControl('', Validators.required);
  dateOfBirthFieldControl = new UntypedFormControl('', Validators.required);
  addressFieldControl = new UntypedFormControl('', Validators.required);
  phoneFieldControl = new UntypedFormControl('', Validators.required);

  serverIsDown = false;

  constructor(private http: HttpClient, private localStorage: LocalStorageService, @Inject(MAT_DIALOG_DATA) public data: Competitor,
              private countryService: CountryService, private httpHandlingService: HttpHandlingService,
              public dialogRef: MatDialogRef<EditCompetitorCardComponent>) {}

  ngOnInit(): void {
    this.countries = Object.values(this.country);
    this.competitor = this.data;
    this.selectedCountry = this.transformCountryCodeCountry(this.competitor.country);
    this.firstName = this.competitor.firstName;
    this.lastName = this.competitor.lastName;
    this.idNumber = this.competitor.idNumber;
    this.dateOfBirth = this.competitor.dateOfBirth;
    this.address = this.competitor.address;
    this.phone = this.competitor.phone;
  }

  /**
   * function for transforming country code from database to Country
   * @param countryCode for evaluating correct Country
   */
  transformCountryCodeCountry(countryCode: string): Country {
    return this.countryService.transformCountryCodeCountry(countryCode);
  }

  /**
   * function which provides error messages in the process of updating competitor card
   * @param fieldControl with information about desired field (firstName, lastName, ...)
   */
  getErrorMessage(fieldControl: UntypedFormControl): string {
    return this.httpHandlingService.handleUserErrorOutput(fieldControl);
  }

  /**
   * function for updating the competitor with provided data
   */
  onUpdateCompetitorCard(): void {
    const editCompetitorURL = SERVER_API_URL + '/api/competitors';
    const competitor = new Competitor(this.competitor.id, this.countryService.transformCountryToCountryCode(this.selectedCountry),
      this.firstName, this.lastName, this.idNumber, this.dateOfBirth, this.address, this.phone,
      this.competitor.role, this.competitor.userId);
    this.http.put<Competitor>(editCompetitorURL, competitor,
      {headers: this.httpHandlingService.authorizationHeaders()}).subscribe(result => {
          const competitorFromServer = result as Competitor;
          const loggedCompetitor = new LoggedCompetitor(competitorFromServer.id, this.firstName, this.lastName,
          competitorFromServer.role, competitorFromServer.userId);
          this.localStorage.set('loggedCompetitor', loggedCompetitor);
        },
      (error: HttpErrorResponse) => { this.handleUpdateErrors(error); },
      () => this.dialogRef.close() );
  }

  /**
   * function for evaluating, if all necessary fields are filled
   * this function disables button, if all data are not provided
   */
  allFieldsAreFilled(): boolean {
    return !(this.firstNameFieldControl.valid && this.lastNameFieldControl.valid &&
      this.idNumberFieldControl.valid && this.dateOfBirthFieldControl.valid && this.addressFieldControl.valid &&
      this.phoneFieldControl.valid);
  }

  /**
   * function for handling HTTP errors in the process of updating competitor card
   */
  handleUpdateErrors(error: HttpErrorResponse): void {
    if (error.status === 0) {
      this.serverIsDown = true;
    }
  }
}
